module.exports = __webpack_public_path__ + "static/maintenance-2518f7440c9bc62fdd4bee4a8d16d3cb.svg";